import React from 'react'
import { useShared } from '../../../../contexts/shared.context';
import { ICardName } from '../../../../types/kato.types';
import SerFullscreen from './ser-fullscreen.component';
import PsdFullscreen from './psd-fullscreen.component';
import PopulationDynamicFullscreen from './population-dynamic-fullscreen.component';
import BudgetInvestmentProjectsFullscreen from './budget-investment-projects-fullscreen.component';
import FoodFullscreen from './food-fullscreen.component';
import IFrameFullscreen from './iframe-fullscreen.component';
import { iframeOptions } from '../../../../consts/navigation.conts';
import RoadFullscreen from './road-fullscreen.component';
import TaxFullscreen from './tax-fullscreen.component';

const Fullscreen = () => {
    const { fullscreen } = useShared();
    return (
        <>
            {fullscreen.type === ICardName.SER && <SerFullscreen />}
            {fullscreen.type === ICardName.PSD && <PsdFullscreen />}
            {fullscreen.type === ICardName.POPULATION_DYNAMIC && <PopulationDynamicFullscreen />}
            {fullscreen.type === ICardName.BUDGET_INVESTMENT_PROJECTS && <BudgetInvestmentProjectsFullscreen />}
            {fullscreen.type === ICardName.FOOD && <FoodFullscreen />}
            {fullscreen.type === ICardName.INFRASTRUCTURE && <IFrameFullscreen
                link={iframeOptions[ICardName.INFRASTRUCTURE].link}
                title={iframeOptions[ICardName.INFRASTRUCTURE].title}
            />}
            {fullscreen.type === ICardName.ROAD && <RoadFullscreen />}
            {fullscreen.type === ICardName.TAX && <TaxFullscreen />}
        </>
    )
}

export default Fullscreen